var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnRoadMarker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 590 590",
    enableBackground: "new 0 0 590 590",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M344.3,245.5c1.5-8.6-0.4-18.4-2.6-28c-7.1-31.2-21.8-58.2-46-80c-15.8-14.1-33.5-24.4-53.4-31.1 c-21.1-7-42.6-8.4-64.6-5.8c-20.6,2.5-39.6,8.9-57.2,19.5c-24.5,14.7-43.1,34.7-56.1,60.1c-12.2,24-17.4,49.2-15.7,76.2 c0.9,13.9,3.6,27.2,7.8,40.2c6,17.9,15.4,34,23.2,51c12.3,26.9,25.7,53.4,38.6,80c11.2,23.1,22.5,46.3,33.8,69.4 c13.8,28.5,27.6,56.9,41.5,85.5c0.6,1.3,0.9,3.2,2.6,3.3c1.9,0,1.9-2,2.5-3.2c7.7-15.8,15.1-31.8,22.8-47.6 c12.2-25.4,24.4-50.8,36.9-76c12.6-25.6,25.1-51.3,37.3-77c10.2-21.5,21.1-42.6,31.4-63.9C338,295.7,345,272.2,344.3,245.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#017EFD",
    d: "M344.3,245.5c0.7,26.7-6.2,50.2-17.1,72.8c-10.3,21.3-21.2,42.4-31.4,63.9c-12.2,25.7-24.7,51.4-37.3,77 c-12.5,25.3-24.5,50.7-36.9,76c-7.7,15.8-15.1,31.8-22.8,47.6c-0.6,1.2-0.6,3.3-2.5,3.2c-1.7,0-2-2-2.6-3.3 c-13.8-28.5-27.7-56.9-41.5-85.5c-11.2-23.1-22.5-46.3-33.8-69.4c-12.9-26.7-26.3-53.2-38.6-80c-7.8-17-17.3-33.1-23.2-51 c-4.4-13.1-7-26.3-7.8-40.2c-1.7-27,3.5-52.3,15.7-76.2c12.9-25.4,31.5-45.5,56.1-60.1c17.7-10.6,36.7-17.1,57.2-19.5 c22.1-2.6,43.6-1.2,64.6,5.8c19.9,6.5,37.6,17,53.4,31.1c24.4,21.6,38.9,48.8,46,80C343.8,226.9,345.7,236.9,344.3,245.5z  M196.6,166.6c-44.6-0.7-81.8,36-81.5,80.7c0.3,44.6,34.4,81.2,81.5,81.2c44,0,78.7-33.7,80.7-78 C279.5,203.4,239.8,165.7,196.6,166.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.6,166.6c43.3-0.9,82.9,36.7,80.7,83.9c-2,44.3-36.7,78-80.7,78c-46.9,0-81.2-36.6-81.5-81.2 C114.8,202.6,152,165.9,196.6,166.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnRoadMarker);
export default __webpack_public_path__ + "static/media/on-road-marker.482c174787d98cdae7620d0d35622969.svg";
export { ForwardRef as ReactComponent };